import authUser from "src/components/HeaderLink/slice/header.slice";
import { combineReducers } from "@reduxjs/toolkit";
import ancptMarginSlice from "src/pages/Dashboard/components/AncptPrice/ancptMargin.slice";
import compSalesSlice from "src/pages/Dashboard/components/CompSales/compSales.slice";
import dashboardSlice from "src/pages/Dashboard/slice/Dashboard.slice";
import priceChangesTileSlice from "src/pages/Dashboard/components/PriceChanges/priceChanges.slice";
import userSlice from "src/pages/Login/user.slice";
import perpInventorySlice from "src/pages/Dashboard/components/PerpetualInventory/perpInventory.slice";
import topWPSASlice from "src/pages/Dashboard/components/TopWPSA/topWPSA.slice";
import reminderTileSlice from "src/pages/Dashboard/components/Reminder/reminderTile.slice";
import itemAlertsSlice from "src/pages/Dashboard/components/ItemAlerts/itemAlerts.slice";
import recentIcareSlice from "src/pages/Dashboard/components/RecentIcare/recentIcare.slice";
import itemBasicDetailsSlice from "src/pages/ItemDetails/slice/basicDetails.slice";
import globalAlertsSlice from "src/components/HeaderLink/modal/GlobalAlerts/slice/globalAlerts.slice";
import inventoryTableData from "src/pages/ItemDetails/slice/inventoryTable.slice";
import salesTableData from "src/pages/ItemDetails/slice/salesTable.slice";
import transactionTableSlice from "src/pages/ItemDetails/slice/transaction.slice";
import noSaleSlice from "src/pages/NoSaleItems/slice/noSale.slice";
import productsSlice from "src/pages/ProductsList/slice/products.slice";
import deptExceptionSlice from "src/pages/DeptExceptions/slice/deptException.slice";
import priceExceptionSlice from "src/pages/PriceExceptions/slice/priceException.slice";
import receiveTypesSlice from "src/pages/ReceiveItems/slice/receiveTypes.slice";
import ManualTransferSlice from "src/pages/CreateEditManualTransfer/slice/ManualTransfer.slice";
import createFreightClaimSlice from "src/pages/CreateFreightClaim/slice/createFc.slice";
import searchShowAllProductsSlice from "src/pages/SearchShowAllProducts/searchShowAllProducts.slice";
import searchShowAllReceivingsSlice from "../pages/SearchShowAllReceivings/searchShowAllReceivings.slice";
import perpInventoryAvgReportslice from "src/pages/PerpInventoryAvgReport/perpInventoryAvgReportslice";
import createInventoryAdjustmentSlice from "src/pages/CreateInventoryAdjustment/createInventoryAdjustment.slice";
import physicalInventorySlice from "src/pages/PhysicalInventory/slice/physicalInventory.slice";
import createYellowSlice from "src/pages/CreateYellow/createYellow.slice";
import dailySalesReportDataSlice from "src/pages/DailySalesReport/slice/dailySalesReport.slice";
import WeeklyReportSlice from "src/pages/WeeklyReceivingReport/weeklyReport.slice";
import salesInquirySlice from "../pages/SalesReport/salesReport.slice";
import transferActivitySlice from "src/pages/TransferActivityReport/slice/transferActivity.slice";
import viewPurchaseReportsTableDataSlice from "../pages/PurchaseRegister/slice/purchaseRegister.slice";
import reportsSlice from "src/pages/Report/slice/reports.slice";
import createOverShortSlice from "src/pages/CreateOverShort/slice/CreateOs.slice";
import editOverShortSlice from "src/pages/EditOverShort/slice/EditOs.slice";
import flashSalesSlice from "src/pages/FlashSalesReport/slice/flashSalesReport.slice";
import flashSalesFilterSlice from "src/pages/FlashSalesReport/slice/filter.slice";
import realTimeSalesReportSlice from "src/pages/RealTimeSalesReport/realTimeSalesReport.slice";
import pricechangesSlice from "src/pages/PriceChangesReport/slice/pricechanges.slice";
import receivingsListSlice from "src/pages/Receiving/receivingList.slice";
import editFreightClaimSlice from "src/pages/EditFreightClaim/slice/EditFc.slice";
import inventoryAdjustmentApproverSlice from "src/pages/CreateInventoryAdjustment/inventoryAdjustmentApprover.slice";
import grossMarginReportSlice from "src/pages/GrossMarginReport/slice/GrossMarginReport.slice";
import TransactionDetailsSlice from "src/pages/TransactionDetails/TransactionDetails.slice";
import editWarehouseTransferSlice from "src/pages/EditWarehouseTransfer/editWarehouseTransfer.slice";
import editDSDSlice from "src/pages/EditDSD/editDSD.slice";
import editDSDCreditSlice from "src/pages/EditDSDCredit/editDSDCredit.slice";
import priceChangesViewAllSlice from "src/pages/PriceChangesViewAll/slice/priceChangesViewAll.slice";
import GlobalSearchSlice from "src/components/GlobalSearchBar/slice/GlobalSearch.slice";
import TransactionLogReportSlice from "src/pages/TransactionLogReport/slice/TransactionLogReport.slice";
import warehouseSlice from "src/config/slices/warehouseList.slices";
import notificationLogSlice from "src/pages/NotificationLog/slice/notificationLog.slice";
import produceMovementRecordSlice from "src/pages/ProduceMovementAndRecord/slice/ProduceMovementAndRecord.slice";

const rootReducer = combineReducers({
  dashboard: dashboardSlice,
  auth: authUser,
  user: userSlice,
  priceChangesTile: priceChangesTileSlice,
  compSales: compSalesSlice,
  ancptMargin: ancptMarginSlice,
  perpInventory: perpInventorySlice,
  topWPSA: topWPSASlice,
  itemAlerts: itemAlertsSlice,
  reminder: reminderTileSlice,
  recentIcare: recentIcareSlice,
  itemBasicDetails: itemBasicDetailsSlice,
  globalAlerts: globalAlertsSlice,
  inventoryTable: inventoryTableData,
  salesTable: salesTableData,
  noSale: noSaleSlice,
  products: productsSlice,
  deptException: deptExceptionSlice,
  priceException: priceExceptionSlice,
  receiveTypes: receiveTypesSlice,
  manualTransfer: ManualTransferSlice,
  createFreightClaim: createFreightClaimSlice,
  searchShowAllProducts: searchShowAllProductsSlice,
  searchShowAllReceivings: searchShowAllReceivingsSlice,
  createInventoryAdjustment: createInventoryAdjustmentSlice,
  physicalInventory: physicalInventorySlice,
  dailySalesReportData: dailySalesReportDataSlice,
  createYellow: createYellowSlice,
  weeklyReport: WeeklyReportSlice,
  createOverShort: createOverShortSlice,
  reports: reportsSlice,
  salesInquiry: salesInquirySlice,
  editOverShort: editOverShortSlice,
  transferActivity: transferActivitySlice,
  flashSales: flashSalesSlice,
  flashSalesFilter: flashSalesFilterSlice,
  viewPurchaseReportsTableData: viewPurchaseReportsTableDataSlice,
  perpInventoryAvgReport: perpInventoryAvgReportslice,
  realtimeSalesReport: realTimeSalesReportSlice,
  priceChanges: pricechangesSlice,
  receivingList: receivingsListSlice,
  editFreightClaim: editFreightClaimSlice,
  inventoryAdjustmentApprover: inventoryAdjustmentApproverSlice,
  grossMarginReport: grossMarginReportSlice,
  transactionTableData: transactionTableSlice,
  transactionDetails: TransactionDetailsSlice,
  editWarehouseTransfer: editWarehouseTransferSlice,
  editDSD: editDSDSlice,
  editDSDCredit: editDSDCreditSlice,
  priceChangesViewAll: priceChangesViewAllSlice,
  globalSearch: GlobalSearchSlice,
  transactionLogReport: TransactionLogReportSlice,
  warehouse: warehouseSlice,
  notificationLog: notificationLogSlice,
  produceMovementRecordData: produceMovementRecordSlice
});

export default rootReducer;
